import React, { memo } from 'react';
import styled from 'styled-components';
import { IconWrapper, SvgIcon } from '../Icon';
import { theme } from '../../styles/theme';

interface IProps {
  totalPages: number;
  activePage: number;
  onPageChange: (pageIndex: number) => void;
}

const Container = styled.div`
  display: inline-flex;
  align-items: center;
  column-gap: 6px;
`;

const Content = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  font-weight: 500;
  color: ${theme.colors.secondary800};
  user-select: none;
`;

export default memo(function Pagination({
  totalPages,
  activePage,
  onPageChange,
}: IProps) {
  const onForwardClick = () => {
    let newPage = activePage + 1;
    if (newPage > totalPages) {
      newPage = 1;
    }
    onPageChange(newPage);
  };
  const onBackwardClick = () => {
    let newPage = activePage - 1;
    if (newPage < 1) {
      newPage = totalPages;
    }
    onPageChange(newPage);
  };
  return (
    <Container>
      <IconWrapper size={16} onClick={onBackwardClick}>
        <SvgIcon
          name="caret-left"
          width={12}
          height={12}
          customFill="currentColor"
        />
      </IconWrapper>

      <Content>{`${activePage}/${totalPages}`}</Content>
      <IconWrapper size={16} onClick={onForwardClick}>
        <SvgIcon
          name="caret-right"
          width={12}
          height={12}
          customFill="currentColor"
        />
      </IconWrapper>
    </Container>
  );
});
